/**
 *
 * Countries
 *
 */

import React, { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import { Breadcrumb, Layout, Spin, Card, Tag, Row, Col } from "antd";
import LeadContext from "../../contexts/leads";
import Country from "../../components/maps/country";
import Leads from "../../components/leads";
import "./styles.css";
import SearchPlaces from "../../components/searchPlace";
import india from "../../utils/images/india.svg";
const { Content } = Layout;

export function Countries() {
  const [data, setData] = useState({ states: [] });
  const [leadCount, setLeadCount] = useState({ count: [] });
  const [loading, setLoading] = useState(true);
  const { supplyApi } = useContext(LeadContext);

  useEffect(() => {
    loadStates();
    loadLeadCount();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toDistrict = slug => {
    window.location.href = `/${slug}`;
  };

  const loadStates = () => {
    setLoading(true);
    supplyApi.get("countries/101-india/").then(response => {
      setData({ states: response.data.states });
      setLoading(false);
    });
  };

  const loadLeadCount = () => {
    setLoading(true);
    supplyApi
      .get("leads/count/?country_id=101")
      .then(response => {
        setLeadCount({ count: response.data.leads });
        setLoading(false);
      });
  };

  if (loading !== false) {
    return <Spin spinning={!loading} />;
  }

  if (data.states.length) {
    var states = data.states.sort(function(a, b) {
      return a.name.localeCompare(b.name);
    });

    const title = (
      <div>
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            <span>
              <img src={india} alt="india" style={{ height: 35, width: 35 }} />
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <SearchPlaces states={data.states} />
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
    );

    return (
      <div>
        <Helmet>
          <title>Zo Supply | India</title>
        </Helmet>

        <Content className="content">
          <Card title={title}>
            <div>
              <Leads id={null} />
            </div>
            <div style={{ height: "50vh" }}>
              <Country />
            </div>
            {states.map(state => {
              return (
                <Card.Grid
                  key={state.name}
                  className="gridStyle"
                  onClick={() => toDistrict(state.slug)}
                >
                  <Row>
                    <Col span={18}>{state.name}</Col>
                    <Col span={6}>
                      {leadCount.count.find(x => x.state_id === state.id) ? (
                        <Tag style={{ marginLeft: 5 }} color="blue">
                          {
                            leadCount.count.find(x => x.state_id === state.id)
                              .count
                          }
                        </Tag>
                      ) : (
                        <Tag style={{ marginLeft: 5 }} color="red">
                          NA
                        </Tag>
                      )}
                    </Col>
                  </Row>
                </Card.Grid>
              );
            })}
          </Card>
        </Content>
      </div>
    );
  }

  return null;
}

export default Countries;
